import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Navbar, Footer } from "../index.ts";
import useApiData from "../../Hooks/FetchApiHooks/index.tsx";
import SideImages from "./Components/SideImages/SideImages.tsx";
import MainImage from "./Components/MainImage/MainImage.tsx";
import ProductDetailButton from "./Components/ProductDetailButton/ProductDetailButton.tsx";
import {
  getDescriptionStyle,
  getImagesContainerStyle,
  getPriceStyle,
  getProductContentContainerStyle,
  getProductDetailContainerStyles,
  getTitleStyle,
} from "./ProductDetails.styles.ts";
import QuantityComponent from "./Components/QuantityComponent/QuantityComponent.tsx";
import ReleaseMobileCarousel from "./Components/ProductDetailMobileCarousel/ProductDetailMobileCarousel.tsx";
import { useCart } from "../../Context/ShoppingCartContext/CartContext.tsx";
import BackButton from "./Components/BackButton/BackButton.tsx";
import { useSendWhatsapp } from "../../Hooks/UseSendToWhatsapp/index.tsx";
import RelatableItems from "./Components/RelatableItems/RelatableItems.tsx";
import CategoriesMobileCarousel from "../Categories/Components/CategoriesMobileCarousel/CategoriesMobileCarousel.tsx";

const ProductDetail = () => {
  const { id } = useParams();
  const { apiData, isLoading } = useApiData();
  const { addToCart } = useCart();
  const { sendProducts } = useSendWhatsapp("5511912297241");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [quantity, setQuantity] = useState(1);

  const product = id
    ? apiData?.data?.find((item) => item.id === Number(id))
    : undefined;

  const [selectedImage, setSelectedImage] = useState(
    product?.imagesrc?.[0] || "",
  );

  const firstFourCategories = (
    apiData?.data
      ?.filter(
        (item) =>
          item.producttype === product?.producttype &&
          item.isActive !== false &&
          item.id !== product.id,
      )
      .sort((a, b) => b.id - a.id)
      .slice(0, 4) ?? []
  ).map((item) => ({
    id: item.id,
    title: item.title,
    imageSrc: item.imagesrc[0],
    imageAlt: item.imagealt,
  }));

  if (isLoading) return <Typography>Carregando...</Typography>;
  if (!product) return <Typography>Produto não encontrado.</Typography>;

  const handleOnClickRelatableItem = (id: number) => {
    window.location.href = `/produto/${id}`;
  };

  return (
    <>
      <Navbar />
      <BackButton />
      <Box sx={getProductDetailContainerStyles}>
        <Box>
          {isMobile ? (
            <ReleaseMobileCarousel product={product} />
          ) : (
            <Box sx={getImagesContainerStyle}>
              {product.imagesrc.length > 1 && (
                <SideImages
                  product={product}
                  setSelectedImage={setSelectedImage}
                />
              )}
              <MainImage product={product} selectedImage={selectedImage} />
            </Box>
          )}
          <Box sx={getProductContentContainerStyle}>
            <Box>
              <Typography sx={getTitleStyle}>{product.title}</Typography>
              <Typography sx={getPriceStyle}>{product.description}</Typography>
            </Box>
            <QuantityComponent quantity={quantity} setQuantity={setQuantity} />
            <ProductDetailButton
              addToCart={() =>
                addToCart({
                  id: product.id,
                  name: product.title,
                  price: product.description,
                  imgSrc: product.imagesrc,
                  imgAlt: product.imagealt,
                  quantity: quantity,
                })
              }
              sendProducts={() =>
                sendProducts([
                  {
                    id: product.id,
                    name: product.title,
                    price: product.description,
                    imgSrc: product.imagesrc,
                    imgAlt: product.imagealt,
                    quantity,
                  },
                ])
              }
            />
            <Typography sx={getDescriptionStyle}>
              {product.largedescription}
            </Typography>
          </Box>
        </Box>
      </Box>

      {isMobile ? (
        <Box paddingY={4}>
          <Typography
            align="center"
            sx={{
              fontSize: "22px",
              fontWeight: "300",
              fontFamily: "kanit",
              paddingBottom: "16px",
            }}
          >
            {"Veja também"}
          </Typography>
          <CategoriesMobileCarousel categoriesOptions={firstFourCategories} />
        </Box>
      ) : (
        <RelatableItems
          handleOnClickRelatableItem={handleOnClickRelatableItem}
          firstFourCategories={firstFourCategories}
        />
      )}
      <Footer />
    </>
  );
};

export default ProductDetail;
